const e=50,o=3e3;export{e as PLAY_BUTTON_HIDE_DEALY,o as YOUTUBE_API_READY_FAIL_FALLBACK_DELAY};
//# sourceMappingURL=constants.js.map
